const sortOrders = {
    ascend: 'ASC',
    descend: 'DESC',
}

const getSortBy = ({ column, field } = {}) => {
    if (column?.sortField) return column.sortField
    return Array.isArray(field) ? field.join('.') : field
}

const sortOrdersByType = {
    ASC: 'ascend',
    DESC: 'descend',
}

// Controls each column's sort arrow from the URL sort, so it survives
// reloads and table remounts (e.g. the list re-renders after every fetch).
export const withSortOrder = (columns, sortBy, sortType) => columns.map((column) => {
    if (!column.sorter) return column
    const isActive = getSortBy({ column, field: column.dataIndex }) === sortBy
    return { ...column, sortOrder: isActive ? (sortOrdersByType[sortType] ?? null) : null }
})

export const normalizeTableSorter = (sorter) => {
    const activeSorter = Array.isArray(sorter) ? sorter.find(({ order }) => order) : sorter
    const sortType = sortOrders[activeSorter?.order]

    return sortType ? {
        sortBy: getSortBy(activeSorter),
        sortType,
    } : {}
}
